export enum HistoryDateFields {
    startDate = "Start date",
    endDate = "End date",
    dueDate = "Due date"
}